module.exports = __webpack_public_path__ + "static/media/1002232.3a26a293.png";